/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../../Fct/generics';
import { getSupportedTokens } from '../../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../../constants';
import { amountOutMinRisk } from '../params';
export var AddLiquidityETH = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'addLiquidityETH',
    description: 'Add liquidity on Uniswap',
    supportedContracts: ROUTER_V2_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                value: new FctValue({ destination: 'wei_amount' }),
                methodParams: {
                    token: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    amountTokenDesired: new FctValue({}),
                    amountTokenMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    amountETHMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountA: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
                amountB: new FctValue({ destination: 'wei_amount', innerIndex: 1 }),
                liquidity: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
            },
        });
    },
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
            amountTokenMin: '0',
            amountETHMin: '0',
        },
    },
    requiredApprovals: function (params) {
        return [
            {
                to: params === null || params === void 0 ? void 0 : params.methodParams.token.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountTokenDesired.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
